import { GroupByMode, GroupSettings, Timestamp } from '@griply/types';
import { startOfDay, subDays } from 'date-fns';

import { COMPLETED_LOOKBACK_DAYS } from './constants/default-completed-filter-document';

export const getCompletedDateGroupSettings = (
  today: Timestamp,
): GroupSettings => ({
  [GroupByMode.CompletedDate]: {
    showRepeatingAsTodo: true,
    completedFromDate: startOfDay(subDays(today, COMPLETED_LOOKBACK_DAYS)),
  },
});
